import { render, staticRenderFns } from "./ConfirmPhoneNumberNew.vue?vue&type=template&id=a87e1b54&"
import script from "./ConfirmPhoneNumberNew.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhoneNumberNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports